import bookingStateSelector from '../selectors/BookingStateSelector';
import {
    COVID_VACCINE_DOSE_1_PROCEDURE_ID,
    COVID_VACCINE_DOSE_2_PROCEDURE_ID,
} from '../constants';

export function isVaccineProcedure(procedureId) {
    const procedureIdInt = parseInt(procedureId, 10);
    return (
        procedureIdInt === COVID_VACCINE_DOSE_1_PROCEDURE_ID ||
        procedureIdInt === COVID_VACCINE_DOSE_2_PROCEDURE_ID
    );
}

export function isBookingStateForCovidVaccine(state) {
    const bookingState = bookingStateSelector(state);
    return isVaccineProcedure(bookingState?.visit_reason);
}
